import React from 'react';
import { Helmet } from 'react-helmet';

interface IProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  keywords?: string;
}

export const OptimizeSEO: React.FC<IProps> = ({
  title = 'Music Porter',
  description = 'Transfer and sync your playlists across Spotify, Apple Music, and YouTube Music in seconds.',
  image = 'https://musicporter.com/preview.png',
  url = 'https://musicporter.com',
  keywords = 'music porter, playlist transfer, spotify, apple music, youtube music',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* <meta property="og:image" content={image} /> */}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter Tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* <meta name="twitter:image" content={image} /> */}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};
